module.exports = __webpack_public_path__ + "media/reward_sound.37b24d70.wav";